var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectricityMeter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "visuel/compteur") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visuel/compteur",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DDD3F1",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uDBC0\\uDEE5",
    transform: "translate(7.872070, 5.176507)",
    fill: "#5A2C71",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.77734375,12.8508369 L8.10351562,6.00122753 C8.203125,5.87818065 8.25585938,5.76099315 8.25585938,5.62622753 C8.25585938,5.40357128 8.08007812,5.2336494 7.83398438,5.2336494 L4.5234375,5.2336494 L6.26953125,0.675055654 C6.50390625,0.0715400286 5.859375,-0.256584971 5.47851562,0.247321279 L0.15234375,7.09107128 C0.052734375,7.21997753 0,7.33716503 0,7.46607128 C0,7.6945869 0.17578125,7.86450878 0.421875,7.86450878 L3.73242188,7.86450878 L1.98632812,12.4172432 C1.75195312,13.0207588 2.39648438,13.3488838 2.77734375,12.8508369 Z M5.0859375,6.9914619 L1.46484375,6.9914619 L4.76953125,2.60279003 L3.16992188,6.10669628 L6.78515625,6.10669628 L3.48046875,10.4953682 L5.0859375,6.9914619 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricityMeter);
export default __webpack_public_path__ + "static/media/electricity-meter.ddebaee7cfe5ead0cd5be7a69641c3f3.svg";
export { ForwardRef as ReactComponent };